import React from "react";
import Lottie from "lottie-react";

import "./outlet-card.scss";
import OfferIcon from "../../assets/offer.json";

const OutletCard = ({
  outetImg,
  outletName,
  outletType,
  onClick,
  outletRate,
  outletPlace,
  outetOffer,
  outletTime
}) => {
  const discType = (type) => {
    switch (type) {
      case "percentage":
        return "%";
      case "flat":
        return "FLAT";
      default:
        return null;
    }
  };
  return (
    <div className="outlet-card-container" onClick={onClick}>
      <img src={outetImg} className="outlet-image" alt="reward icon" />
      <div className="outlet-content">
        <div className="content-top">
          <div className="name">{outletName}</div>
          {/* <div className="rating">{"rating"}</div> */}
        </div>
        <div className="content-mid">
          <div className="type">{outletPlace}</div>
          <div className="rate-section">
            <span>&#8377;</span>
            {outletRate}
          </div>
        </div>
        <div className="content-bottom">
          <div className="outlet-type-section">
            {outletType}
          </div>
          <div className="timings-section">
            {outletTime}
          </div>
        </div>
        {outetOffer && Object.keys(outetOffer).length > 0 && outetOffer.offerName ? ( 
        <>
        <hr className="dashed-line" />
        <div className="offer-section">
          <div className="offer-icon">
            <Lottie loop={true} animationData={OfferIcon} />
          </div>
          {/* <span className="offer-value">{outetOffer?.discountValue}</span>
          <span className="offer-type">
            {discType(outetOffer?.discountType)}
          </span> */}
          <span className="offer-name">{outetOffer?.offerName}</span>
        </div>
        </>)
        :null}
      </div>
    </div>
  );
};

export default OutletCard;
